var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Distrikts',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.step == 0),expression:"$store.step == 0"}]}),(_vm.$store.step == 1)?_c('Cards'):_vm._e(),(_vm.$store.step == 2)?_c('Form'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }